import React, {useState} from 'react';
import {Button, Form} from "react-bootstrap";
import {onLogin, SecondaryAuthorizationData, SecondaryIdentifier} from "./api";
import PropTypes, { InferProps } from 'prop-types';
import CurrentState from './CurrentStateEnum';
import {useTranslation} from "react-i18next";


export default function Auth({setSecondaryAuthorizationData, setCustomerName, setCurrentState, setAccounts, setError, setRendering, renderError, renderSpinner} : InferProps<typeof Auth.propTypes>) {

    const {t} = useTranslation();

    const [{loginId, withKeyToken}, setCredentials] = useState({
        loginId:'',
        withKeyToken:''
    });

    const [validated, setValidated] = useState(false);

    const validateForm = () : boolean=>{
        if(loginId.length < 8 || withKeyToken.length < 6){
            setValidated(true);
            return false;
        }
        setValidated(false);
        return true;
    };

    const submit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if(!validateForm()){
            return;
        }

        const form = event.currentTarget;
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
        }

        setRendering(true);

        const response = await onLogin({
            loginId: loginId,
            withKeyToken
        });

        if (response === null){
            setError(t("helper.errorMessage"));
            setRendering(false);
        } else {
            if(response.errorMessage === null){
                setCustomerName(response.customerName);

                setAccounts(response.accounts);
                if (response.accounts.length > 0){
                    setSecondaryAuthorizationData(
                        {
                            account: response.accounts[0],
                            secondaryIdentifier: {
                                phoneNumber: "+36-",
                                email: ""
                            } as SecondaryIdentifier
                        } as SecondaryAuthorizationData
                    );
                }
                setRendering(false);
                setError("");
                setCurrentState(CurrentState.SecondaryAuthForm);
            } else{
                setError(t(response.errorMessage));
                setRendering(false);
            }
        }

    };

    const change = (event: React.FormEvent<HTMLInputElement>) => {
        let inputValue: string = event.currentTarget.value;
        let id: string = event.currentTarget.id;

        if (!isNaN(Number(inputValue))) {
            id === "loginId" ?
                setCredentials({
                    loginId: inputValue,
                    withKeyToken
                }) :
                setCredentials({
                    withKeyToken: inputValue,
                    loginId: loginId
                });
        }
    };

    const getClassName = () => {
        if(validated){
            return "invalid_input";
        }
    };

    return (
        <div>
            <div className="container">
                <p className={"header"}>{t("authPage.welcome")}</p>
                <p className={"description"}>{t("authPage.description")}</p>
            </div>
            <Form
                onSubmit={((event:React.FormEvent<HTMLFormElement>) => submit(event))}
            >
                {renderError()}
                <Form.Group controlId="loginId">
                    <Form.Label>{t("authPage.loginId")}</Form.Label>
                    <Form.Control
                        className = {getClassName()}
                        placeholder={t("authPage.loginIdPlaceholder")}
                        value={loginId}
                        maxLength={8}
                        onChange={(event) => change(event as any)}
                    />
                    {
                        validated && <div className={"invalid_message"}>{t("authPage.loginIdInvalidMessage")}</div>
                    }
                </Form.Group>

                <Form.Group controlId="withKeyToken">
                    <Form.Label>{t("authPage.token")}</Form.Label>
                    <Form.Control
                        className={getClassName()}
                        placeholder= {t("authPage.tokenPlaceholder")}
                        value={withKeyToken}
                        maxLength={6}
                        type="password"
                        onChange={(event) => change(event as any)}
                    />
                    {
                        validated && <div className={"invalid_message"}>{t("authPage.tokenInvalidMessage")}</div>
                    }
                </Form.Group>
                <Button type="submit">
                    {renderSpinner()}
                    {t("authPage.login")}
                </Button>

            </Form>
        </div>
    );
};

Auth.propTypes = {
    setSecondaryAuthorizationData: PropTypes.func.isRequired,
    setCustomerName: PropTypes.func.isRequired,
    setCurrentState: PropTypes.func.isRequired,
    setAccounts: PropTypes.func.isRequired,
    setError: PropTypes.func.isRequired,
    setRendering: PropTypes.func.isRequired,
    renderError: PropTypes.func.isRequired,
    renderSpinner: PropTypes.func.isRequired,
};
